import { render, staticRenderFns } from "./PenggalianViewEmail.vue?vue&type=template&id=1dde61b0&scoped=true&lang=pug&"
import script from "./PenggalianViewEmail.vue?vue&type=script&lang=js&"
export * from "./PenggalianViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./PenggalianViewEmail.vue?vue&type=style&index=0&id=1dde61b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde61b0",
  null
  
)

export default component.exports